<template>
	<ul class="list-group hover pointer">
		<li class="list-group-item" @click="goto('admin')" :class="{ selected: page == 'admin' }"><a>Home</a></li>
		<li class="list-group-item" @click="goto('users')" :class="{ selected: page == 'users' }"><a>Users</a></li>
		<li class="list-group-item" @click="goto('districts')" :class="{ selected: page == 'districts' }">
			<a>Districts</a>
		</li>
		<li class="list-group-item" @click="goto('activity')" :class="{ selected: page == 'activity' }">
			<a>Activity</a>
		</li>
		<li class="list-group-item" @click="goto('schools')" :class="{ selected: page == 'schools' }">
			<a>Schools</a>
		</li>
		<li class="list-group-item" @click="goto('sections')" :class="{ selected: page == 'sections' }">
			<a>Classes</a>
		</li>
		<li class="list-group-item" @click="goto('contests')" :class="{ selected: page == 'contests' }">
			<a>Contests</a>
		</li>
		<li class="list-group-item" @click="goto('programs')" :class="{ selected: page == 'programs' }">
			<a>Programs</a>
		</li>
		<li class="list-group-item item-expand" @click="expandScoring" :class="{ active: scoringExpanded }">
			<a>Score Portfolios</a>
		</li>
			<li
				class="list-group-item sub-item"
				@click="goto('score?view=student')"
				:class="{selected: scoringView == 'student' }"
				v-if="scoringExpanded"
			>
				<a>By Student</a>
			</li>

			<li
				class="list-group-item sub-item"
				@click="goto('score?view=teacher')"
				:class="{selected: scoringView == 'teacher' }"
				v-if="scoringExpanded"
			>
				<a>By Teacher</a>
			</li>

			<li
				class="list-group-item sub-item"
				@click="goto('score?view=master')"
				:class="{selected: scoringView == 'master' }"
				v-if="scoringExpanded"
			>
				<a>Master Files</a>
			</li>
		<!-- <li class="list-group-item">
			<a @click="goto('uploader_test')">Uploader Test</a>
		</li> -->
	</ul>
</template>

<style scoped>
.list-group-item {
	font-size: 18px;
	font-family: Blender Pro;
	transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
.list-group-item.selected {
	background-color: rgba(41, 204, 232, 0.8);
	border-color: rgb(3, 155, 182);
	color: white;
}
.item-expand::after {
	content: '';
	border-left: 8px solid rgb(32, 32, 32);
	border-top: 7px solid transparent;
	border-bottom: 7px solid transparent;
	float: right;
	position: relative;
	margin-top: 5px;
	transition: transform 0.15s ease-in-out;
}
.item-expand.active::after {
	transform: rotate(90deg);
}
.sub-item {
	font-size: 16px;
	padding-left: 50px;
}
.list-group-item:not(.selected):hover {
	background-color: rgba(0, 0, 0, 0.05);
}
.list-group-item.selected:hover {
	background-color: rgba(41, 204, 232, 0.8);
}
.list-group-item:not(.selected):active {
	border-color: rgba(41, 204, 232, 1);
}
</style>

<script>
export default {
	name: "AdminNav",
	props: [],

	data() {
		return {
			scoringExpanded: false,
			scoringView: "",
		};
	},
	created() {
		let path = this.$route.path;
		let parts = path.split("/");
		if (parts.length >= 2) {
			this.page = parts[1];
		}
		if (this.page == 'score') {
			this.scoringExpanded = true;
			this.scoringView = this.$route.query.view;
		}
	},
	watch: {},
	methods: {
		expandScoring() {
			this.scoringExpanded = !this.scoringExpanded;
		},
		goto(path) {
			//   this.$router.push({ path: path });
			window.location.href = "/#/" + path;
		},
	},
};
</script>